import {
  PostApiOrganizationsByIdLogoApiResponse,
  PostApiOrganizationsByIdQuestionsRequestsApiResponse,
  PostApiOrganizationsByIdUsersInvitesFilesTemplateApiArg,
  PostApiOrganizationsByIdUsersInvitesFilesTemplateApiResponse,
} from 'src/redux/openapi';
import {
  emptySplitApi as api
} from 'src/redux/openapi/emptyApi';

type PostOrgInviteFileTemplateArgs =
  PostApiOrganizationsByIdUsersInvitesFilesTemplateApiArg & {
    formData: FormData;
  };

type PostOrgLogoFileArgs = {
  id: string;
  formData: FormData;
};

type PostOrgLoginCoverArgs = {
  id: string;
  formData: FormData;
};

type PostOrgRequestSubdomainArgs = {
  id: string;
  subdomain: string;
};

export const organizationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    postOrgInviteFileTemplate: build.mutation<
    PostApiOrganizationsByIdUsersInvitesFilesTemplateApiResponse,
    PostOrgInviteFileTemplateArgs
    >({
      query: (queryArg) => ({
        url: `/api/organizations/${queryArg.id}/users/invites/files/template`,
        method: 'POST',
        body: queryArg.formData,
      }),
      invalidatesTags: ['Template'],
    }),
    postOrgLogoFile: build.mutation<
    PostApiOrganizationsByIdLogoApiResponse,
    PostOrgLogoFileArgs
    >({
      query: (queryArg) => ({
        url: `/api/organizations/${queryArg.id}/logo`,
        method: 'POST',
        body: queryArg.formData,
      }),
    }),
    postOrgQuestionsRequests: build.mutation<
    PostApiOrganizationsByIdQuestionsRequestsApiResponse,
    PostApiOrganizationsByIdQuestionsRequestsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/organizations/${queryArg.id}/questions/requests`,
        method: 'POST',
        body: queryArg.file,
      }),
    }),
    patchOrgLoginCover: build.mutation<
    { message: string; data: { loginCoverPhotoUrl: string } },
    PostOrgLoginCoverArgs
    >({
      query: ({
        id, formData
      }) => ({
        url: `/api/organizations/${id}/custom-login/login-cover`,
        method: 'PATCH',
        body: formData,
      }),
    }),
    postOrgRequestSubdomain: build.mutation<
    { message: string },
    PostOrgRequestSubdomainArgs
    >({
      query: ({
        id, subdomain
      }) => ({
        url: `/api/organizations/${id}/custom-login/subdomain`,
        method: 'POST',
        body: {
          subdomain
        },
      }),
    }),
  }),
});

type PostApiOrganizationsByIdQuestionsRequestsApiArg = {
  id: string;
  file: FormData;
};

export const {
  usePostOrgInviteFileTemplateMutation,
  usePostOrgLogoFileMutation,
  usePostOrgQuestionsRequestsMutation,
  usePatchOrgLoginCoverMutation,
  usePostOrgRequestSubdomainMutation,
} = organizationsApi;
